angular.module('filters').filter('stateParamsToBoolean', function() {
  return function(obj) {
    return _.mapObject(obj, function(val) {
      if (!_.isNull(val)) {
        if (val === 'true' || val === 'false') {
          return val === 'true';
        } else {
          return val;
        }
      }
    });
  };
});
